export default __webpack_public_path__ + "static/media/smartphone.ba1ece5a.png";